export { MultilingualClient } from './multilingual-client.js';
export type { Translations } from './multilingual-client.js';
export { useMultilingualClient } from './useMultilingualClient.js';
